import { gql } from "@apollo/client"
import {
  DISTRIBUTION_CENTER_DETAIL_FRAG,
  STORAGE_LOCATION_FRAG,
} from "./distribution-center.fragments.gql"

export const ADD_DISTRIBUTION_CENTER = gql`
  mutation AddDC(
    $address: AddressInput
    $colorCode: String
    $name: String
    $photos: [MediaInput]
    $pointOfContacts: [ID]
    $areaCatered: Geometry
    $customerCode: String!
    $plantCode: String!
    $storeCode: String!
    $primaryPocId: NullableID
    $companyCode: String
    $salesOfcCode: String
    $partnerCode: String
    $deliveryConditions: DeliveryConditionInput
    $assignedCpc: NullableID
    $groupVisibility: [ID]
    $allowedDepartments: [Int]
  ) {
    addDistributionCentre(
      address: $address
      areaCatered: $areaCatered
      name: $name
      photos: $photos
      pointOfContacts: $pointOfContacts
      colorCode: $colorCode
      customerCode: $customerCode
      plantCode: $plantCode
      storeCode: $storeCode
      primaryPocId: $primaryPocId
      companyCode: $companyCode
      salesOfcCode: $salesOfcCode
      partnerCode: $partnerCode
      assignedCpcId: $assignedCpc
      deliveryConditions: $deliveryConditions
      groupVisibility: $groupVisibility
      allowedDepartments: $allowedDepartments
    ) {
      distributionCentre {
        id
        geometry {
          coordinates
          type
        }
        properties {
          ...DistributionCenterDetailFrag
        }
      }
    }
  }
  ${DISTRIBUTION_CENTER_DETAIL_FRAG}
`

export const UPDATE_DISTRIBUTION_CENTER = gql`
  mutation UpdateDC(
    $id: ID!
    $address: AddressInput
    $deliveryConditions: DeliveryConditionInput
    $deliverySlots: [TimeSlotInput]
    $colorCode: String
    $currentStockPercentage: CustomGenericScalar
    $name: String
    $photos: [MediaInput]
    $pickupSlots: [TimeSlotInput]
    $pointOfContacts: [ID]
    $maintenanceSlots: [TimeSlotInput]
    $certifications: [GeneralCertificationInput]
    $areaCatered: Geometry
    $customerCode: String
    $plantCode: String
    $storeCode: String
    $primaryPocId: NullableID
    $companyCode: String
    $salesOfcCode: String
    $partnerCode: String
    $assignedCpc: NullableID
    $groupVisibility: [ID]
    $bankDetails: [BankDetailInput]
    $surveyAreas: [SurveyAreaInput]
    $archive: Boolean
    $allowedDepartments: [Int]
    $alternateSalesSlots: [TimeSlotInput]
  ) {
    updateDistributionCentre(
      id: $id
      address: $address
      areaCatered: $areaCatered
      deliveryConditions: $deliveryConditions
      deliverySlots: $deliverySlots
      certifications: $certifications
      name: $name
      photos: $photos
      bankDetails: $bankDetails
      pickupSlots: $pickupSlots
      pointOfContacts: $pointOfContacts
      colorCode: $colorCode
      maintenanceSlots: $maintenanceSlots
      customerCode: $customerCode
      plantCode: $plantCode
      storeCode: $storeCode
      primaryPocId: $primaryPocId
      companyCode: $companyCode
      salesOfcCode: $salesOfcCode
      partnerCode: $partnerCode
      assignedCpcId: $assignedCpc
      groupVisibility: $groupVisibility
      surveyAreas: $surveyAreas
      archive: $archive
      allowedDepartments: $allowedDepartments
      alternateSalesSlots: $alternateSalesSlots
      currentStockPercentage: $currentStockPercentage
    ) {
      distributionCentre {
        id
        geometry {
          coordinates
          type
        }
        properties {
          ...DistributionCenterDetailFrag
        }
      }
    }
  }
  ${DISTRIBUTION_CENTER_DETAIL_FRAG}
`

export const ADD_UPDATE_STORAGE_LOCATION = gql`
  mutation AddUpdateStorageLocation(
    $id: ID
    $distributionCentreId: ID!
    $name: String
    $codename: String
    $colorCode: String
    $responsiblePersonId: ID!
    $subLocations: [DCSubLocationInput]
    $archive: Boolean
  ) {
    addUpdateDcStorageLocation(
      id: $id
      distributionCentreId: $distributionCentreId
      name: $name
      codename: $codename
      colorCode: $colorCode
      responsiblePersonId: $responsiblePersonId
      subLocations: $subLocations
      archive: $archive
    ) {
      storageLocation {
        ...StorageLocationFrag
      }
    }
  }
  ${STORAGE_LOCATION_FRAG}
`

export const ADD_UPDATE_DC_STOCK_TAKE = gql`
  mutation AddUpdateDCStockTake(
    $id: ID
    $distributionCentreId: ID!
    $itemCategory: String
    $startDay: Int
    $startTime: Time
    $endDay: Int
    $endTime: Time
  ) {
    addUpdateDcStockTakeConfig(
      id: $id
      distributionCentreId: $distributionCentreId
      itemCategory: $itemCategory
      startDay: $startDay
      startTime: $startTime
      endDay: $endDay
      endTime: $endTime
    ) {
      stockConfig {
        id
        startDay
        startTime
        endDay
        endTime
        itemCategory
        distributionCentre {
          id
          name
        }
      }
    }
  }
`

export const DELETE_DC_PAYMENT_METHOD = gql`
  mutation DeleteDCPaymentMethod($ids: [ID]!) {
    deleteBankDetail(ids: $ids) {
      response
    }
  }
`

export const DELETE_DC_CERTIFICATION = gql`
  mutation DeleteDCCertification($ids: [ID]!) {
    deleteCertification(ids: $ids) {
      response
    }
  }
`
